import { render } from "./ProfileName.vue?vue&type=template&id=34a14cbd"
import script from "./ProfileName.vue?vue&type=script&lang=js"
export * from "./ProfileName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__